// a function trying to handle any possible case of error data.
import { HttpErrorResponse } from '@angular/common/http';
import { AppMessage } from '../messages';
// aims to return a simple stringified error message.
export function errorToErrorPageData(error, defaults) {
  let data = {
    ...defaults
  };
  if (error instanceof AppMessage) {
    data.message = error.message;
    data.summary = error.summary;
    data.status = error.status;
    data.errorName = error.getError()?.name;
    error.setHandled(true);
  } else if (error instanceof HttpErrorResponse) {
    // unwrap the server error from httpErrorResponse
    data.status = error.status;
    data.message = error.error.message;
    data.errorName = error.name;
    data.summary = 'Serverfehler';
  } else if (error instanceof Error) {
    data.summary = error.name;
    data.errorName = error.name;
    data.message = error.message;
  } else if (typeof error === 'object' && error !== null) {
    data.errorName = error.name || 'Unbekannter Fehler';
    data.message = error.message || error.toString();
  } else {
    data.message = '' + error;
  }
  if (data.errorName === 'Error') {
    data.errorName = 'Fehler';
  }
  return data;
}